module.exports = __webpack_public_path__ + "static/media/texture (37).4eb5851b.jpg";